// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s3qvHnCjJ4FQDMEwCPlJ{padding:40px 0 24px;display:flex;flex-direction:column;gap:8px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/numbers/pages/AddNumber/ui/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,YAAA,CACA,qBAAA,CACA,OAAA","sourcesContent":[".content {\n  padding: 40px 0 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `s3qvHnCjJ4FQDMEwCPlJ`
};
export default ___CSS_LOADER_EXPORT___;
